import { Card, CardBody, NumberDisplay, Button } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../Localization';

export type QueueCardProps = {
  name: string;
  description?: string;
  inQueue: number;
  inReview: number;
  completed: number;
  onClaimApplicant: () => void;
  isLoading?: boolean;
  hasSubmitCompleteField?: boolean;
};

export const QueueCard = ({
  name,
  description,
  inQueue,
  inReview,
  completed,
  onClaimApplicant,
  isLoading = false,
  hasSubmitCompleteField = true
}: QueueCardProps) => {
  const L = useLocalizedStrings();

  return (
    <Card className="rounded-lg">
      <CardBody>
        <div className="flex flex-col gap-4">
          {/* Queue Header */}
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{name}</h3>
              {description && (
                <p className="text-sm text-gray-600 mt-1">{description}</p>
              )}
            </div>
            <Button
              size="sm"
              onClick={onClaimApplicant}
              isDisabled={inQueue === 0 || isLoading}
            >
              {L.admin_panel.reviews.claim_next_applicant}
            </Button>
          </div>

          {/* Stats Cards */}
          <div className="flex flex-col sm:flex-row gap-4">
            <NumberDisplay
              loading={isLoading}
              className="sm:max-w-64 min-w-64"
              title={L.admin_panel.reviews.in_this_queue}
              value={inQueue}
              iconName="ClockIcon"
              iconColor="blue"
            />
            <NumberDisplay
              loading={isLoading}
              className="sm:max-w-64 min-w-64"
              title={L.admin_panel.reviews.in_review}
              value={hasSubmitCompleteField ? inReview : undefined}
              iconName="EyeIcon"
              iconColor="blue"
            />
            <NumberDisplay
              loading={isLoading}
              className="sm:max-w-64 min-w-64"
              title={L.admin_panel.reviews.completed}
              value={hasSubmitCompleteField ? completed : undefined}
              iconName="CheckCircleIcon"
              iconColor="green"
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
